/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 根据项目来源查询场次分区
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class GetSectionInfoParams {
  constructor(
    public distributionChannelId?: string,
    public distributionSeriesId?: string
  ) {}
}

export default async function (
  showId: number,

  params: GetSectionInfoParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: good.SectionDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/show/section/${showId}`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
